import {
  CreateBudgetovacPositionDocument,
  type CreateBudgetovacPositionMutation,
  type CreateBudgetovacPositionMutationVariables,
} from "@src/__generated__/graphql";
import { BudgetPositionFormStore } from "@src/components/modules/budgets/positions/stores/base";
import { MutationHelper } from "@src/helpers/apollo/mutation";
import { DisclosureState } from "@src/utils/mobx/states/DisclosureState";
import { action, computed, makeObservable } from "mobx";
import type { FormEvent } from "react";

export class BudgetPositionCreateStore extends BudgetPositionFormStore {
  disclosure = new DisclosureState({
    onClose: () => {
      this.form.reset();
    },
  });

  private createMutator = new MutationHelper<
    CreateBudgetovacPositionMutation,
    CreateBudgetovacPositionMutationVariables
  >(CreateBudgetovacPositionDocument);

  constructor(
    private onCreate?: (
      position: CreateBudgetovacPositionMutation["createBudgetovacPosition"],
    ) => void,
  ) {
    super();
    makeObservable(this);

    this.fetchDepartments();
  }

  @computed
  get isSubmitting(): boolean {
    return this.createMutator.isLoading.value;
  }

  @action.bound
  async createPosition(event?: FormEvent): Promise<boolean> {
    event?.preventDefault();
    event?.stopPropagation();

    const res = await this.form.validate();
    if (res.hasError) return false;

    const [data, error] = await this.createMutator.mutate({
      input: {
        name: res.value.name.$,
        department_id: res.value.department_id.$,
      },
    });

    if (error) return false;

    this.onCreate?.(data.createBudgetovacPosition);
    this.disclosure.onClose();

    return true;
  }
}
